import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, map, Observable, of } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
    providedIn: 'root',
})
export class UserInfoService {
    private readonly platformId = inject(PLATFORM_ID);
    private ip$?: Observable<string>;

    constructor(
        private apiService: ApiService,
        private readonly router: Router
    ) {}

    getCurrentUrl(): string {
        return this.router.url;
    }

    // Get Current Visits
    getVisitData(): Observable<{ [key: string]: number }> {
        if (!isPlatformBrowser(this.platformId)) return of({});
        let visitData = JSON.parse(sessionStorage.getItem('visitData') || '{}');
        return of(visitData);
    }

    // Update Current Visits
    updateVisitData(): void {
        if (!isPlatformBrowser(this.platformId)) return;

        const currentUrl = this.getCurrentUrl();
        let visitData = JSON.parse(sessionStorage.getItem('visitData') || '{}');

        visitData[currentUrl] = (visitData[currentUrl] || 0) + 1;

        sessionStorage.setItem('visitData', JSON.stringify(visitData));
    }

    // Get Current Market
    getCurrentMarket(): Observable<string> {
        if (!isPlatformBrowser(this.platformId)) return of('');

        return of(sessionStorage.getItem('currentMarket') || '');
    }

    // Get Current Engine Data
    getEngineData(): Observable<any> {
        if (!isPlatformBrowser(this.platformId)) return of(undefined);

        return of(JSON.parse(sessionStorage.getItem('engineData') || '{}'));
    }

    // Get lang
    getLanguage(): Observable<string> {
        if (!isPlatformBrowser(this.platformId)) return of('es');

        let language: string = 'es';
        const storedLanguage = localStorage.getItem('language');
        try {
            if (storedLanguage) {
                language = JSON.parse(storedLanguage).locate;
            }
        } catch (error) {
            console.error('Error parsing language from localStorage:', error);
        }
        return of(language);
    }

    // private getUserIpCached(): Observable<string> {
    //     if (this.ip$) {
    //         return this.ip$;
    //     }

    //     if (!isPlatformBrowser(this.platformId)) return of('');

    //     const stored = sessionStorage.getItem('userIp');
    //     this.ip$ = stored
    //         ? of(stored)
    //         : this.apiService.getUserIp().pipe(
    //               tap((ip) => sessionStorage.setItem('userIp', ip)),
    //               shareReplay({ bufferSize: 1, refCount: true })
    //           );
    //     return this.ip$ || of('');
    // }

    getHotelId(): Observable<number | null> {
        if (!isPlatformBrowser(this.platformId)) return of(0);

        return of(Number(sessionStorage.getItem('hotelId')) || 1);
    }

    // Get UserInfo
    getUserInfo(): Observable<any> {
        return combineLatest([
            this.getVisitData(),
            this.getCurrentMarket(),
            this.getEngineData(),
            this.getLanguage(),
            this.getHotelId(),
        ]).pipe(
            map(
                ([
                    visitCounts,
                    currentMarket,
                    engineData,
                    language,
                    hotelId,
                ]) => ({
                    language,
                    url: this.getCurrentUrl(),
                    visitCounts,
                    currentMarket,
                    hotelId,
                    ...(engineData || {}),
                })
            )
        );
    }
}
